import React, { useEffect } from "react";
import "./SupplyCompanies.css";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import Cardtso from "./Elements/Cardtso";
import Cardcompanies from "./Elements/Cardcompanies";
import Cardstar from "./Elements/Cardstar";
import VideoLower from "./Elements/VideoLower";
import { NavLink } from "react-router-dom";

const SupplyCompanies = () => {
    const { t } = useTranslation();
    var lang = i18n.language;

    document.title = t("page-title.elsupply");

    return (
        <div className="UISupplyCompanies">
            <div className="container-fluid background">
                <div className="bg-image">
                    <VideoLower />
                </div>
                <div className="container">
                    <div className="heading">
                        <h2>{t("elsupply.companies_title")}</h2>
                        <h1>{t("pages.elsupply")}</h1>
                    </div>
                </div>
            </div>
            <div className="container hero-image">
                <img
                    src={`${process.env.PUBLIC_URL}/images/products/business.png`}
                    alt=""
                    className="starter-whatwedo"
                />
            </div>
            <div className="overlay">
                <img src={`${process.env.PUBLIC_URL}/images/w-overlay-tr.svg`} alt="" />
            </div>


            <div className="container content">
                <div className="text">
                    <p>{t("elsupply.companies.text_1")}</p>
                    <NavLink to={t("url.contact")} className="btn-primary" exact>
                        {t("elsupply.companies.button_1")}
                    </NavLink>
                </div>
            </div>
            <div className="container content">
                <div className="heading mb-5">
                    <h4>{t("elsupply.companies.subtitle_1")}</h4>
                    <h3>{t("elsupply.companies.title_1")}</h3>
                </div>
                <div className="text">
                    <p>{t("elsupply.companies.text_2")}</p>
                </div>
                <div className="supply_icons">
                    <div className="icon">
                        <img src={`${process.env.PUBLIC_URL}/images/icons/households_1.png`} alt="" className="icon_image" />
                        <div className="icon_title heading">
                            <h4>{t("elsupply.companies.icon_title_1")}</h4>
                        </div>
                        <div className="icon_text">
                            <p>{t("elsupply.companies.icon_text_1")}</p>
                        </div>
                    </div>
                    <div className="icon">
                        <img src={`${process.env.PUBLIC_URL}/images/icons/households_2.png`} alt="" className="icon_image" />
                        <div className="icon_title heading">
                            <h4>{t("elsupply.companies.icon_title_2")}</h4>
                        </div>
                        <div className="icon_text">
                            <p>{t("elsupply.companies.icon_text_2")}</p>
                        </div>
                    </div>
                    <div className="icon">
                        <img src={`${process.env.PUBLIC_URL}/images/icons/households_3.png`} alt="" className="icon_image" />
                        <div className="icon_title heading">
                            <h4>{t("elsupply.companies.icon_title_3")}</h4>
                        </div>
                        <div className="icon_text">
                            <p>{t("elsupply.companies.icon_text_3")}</p>
                        </div>
                    </div>
                    <div className="icon">
                        <img src={`${process.env.PUBLIC_URL}/images/icons/households_4.png`} alt="" className="icon_image" />
                        <div className="icon_title heading">
                            <h4>{t("elsupply.companies.icon_title_4")}</h4>
                        </div>
                        <div className="icon_text">
                            <p>{t("elsupply.companies.icon_text_4")}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container content">
                <div className="heading mb-5">
                    <h4>{t("elsupply.companies.subtitle_2")}</h4>
                    <h3>{t("elsupply.companies.title_2")}</h3>
                </div>
                <div className="text">
                    <p>{t("elsupply.companies.text_3")}</p>
                </div>
                <div className="boxes">
                    <div className="box greybg">
                        <img src={`${process.env.PUBLIC_URL}/images/products/box_image_1.png`} alt="" className="box_image" />
                        <div className="box_title heading">
                            <h4>{t("elsupply.companies.box_title_1")}</h4>
                        </div>
                        <div className="box_text">
                            {t("elsupply.companies.box_text_1")}
                        </div>
                    </div>
                    <div className="box small_boxes">
                        <div className="small_box greybg">
                            <img src={`${process.env.PUBLIC_URL}/images/products/box_image_2.png`} alt="" className="box_image" />
                            <div className="box_title heading">
                                <h4>{t("elsupply.companies.box_title_2")}</h4>
                                {t("elsupply.companies.box_text_2")}
                            </div>
                        </div>
                        <div className="small_box greybg">
                            <img src={`${process.env.PUBLIC_URL}/images/products/box_image_3.png`} alt="" className="box_image" />
                            <div className="box_title heading">
                                <h4>{t("elsupply.companies.box_title_3")}</h4>
                                {t("elsupply.companies.box_text_3")}
                            </div>
                        </div>
                        <div className="small_box greybg">
                            <img src={`${process.env.PUBLIC_URL}/images/products/box_image_4.png`} alt="" className="box_image" />
                            <div className="box_title heading">
                                <h4>{t("elsupply.companies.box_title_4")}</h4>
                                {t("elsupply.companies.box_text_4")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container content">
                <div className="heading mb-5">
                    <h3>{t("elsupply.companies.title_3")}</h3>
                </div>
                <div className="functions">
                    <div className="function">
                        <div className="function_number"><span>1</span></div>
                        <div className="function_title heading">
                            <h4>{t("elsupply.companies.function_title_1")}</h4>
                            {t("elsupply.companies.function_text_1")}</div>
                    </div>
                    <div className="function">
                        <div className="function_number"><span>2</span></div>
                        <div className="function_title heading">
                            <h4>{t("elsupply.companies.function_title_2")}</h4>
                            {t("elsupply.companies.function_text_2")}</div>
                    </div>
                    <div className="function">
                        <div className="function_number"><span>3</span></div>
                        <div className="function_title heading">
                            <h4>{t("elsupply.companies.function_title_3")}</h4>
                            {t("elsupply.companies.function_text_3")}</div>
                    </div>
                </div>
            </div>

            <div className="container content">
                <div className="heading mb-3 text-start">
                    <h3>{t("elsupply.companies.sm_title")}</h3>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-7 col-lg-9">
                        <div className="text">
                            {t("elsupply.companies.sm_text_1")}
                            <div className="meter_box greybg">
                                <div className="box_content">
                                    {t("elsupply.companies.sm_text_2")}
                                    <div className="box_row">
                                        <a href="https://apps.apple.com/si/app/ngen-energy/id6448929330" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/appstore.png`} alt="" /></a>
                                        <a href="https://play.google.com/store/apps/details?id=ngen.mobile.app" target="_blank" rel="noopener noreferrer"><img src={`${process.env.PUBLIC_URL}/images/googleplay.png`} alt="" /></a>
                                    </div>
                                </div>
                                <img src={`${process.env.PUBLIC_URL}/images/products/sg_logo.png`} alt="" className="sglogo" />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-5 col-lg-3">
                        <img src={`${process.env.PUBLIC_URL}/images/products/smart_meter.png`} alt="" className="smart_meter" />
                    </div>
                </div>
            </div>

            <div className="container content change">
                <div className="card">
                    <img src={`${process.env.PUBLIC_URL}/images/cards/change_bg.png`} alt="Gospodinjstva" />
                    <div className="card-text">
                        <h3>{t("elsupply.companies.zd_title")}</h3>
                        <p>{t("elsupply.companies.zd_text_1")}</p>
                        <br />
                        <a href={t('elsupply.url_households')} exact class="btn btn-secondary">{t('elsupply.companies.zd_button_1')}</a>
                        <a href={t('elsupply.url_companies')} exact class="btn btn-secondary">{t('elsupply.companies.zd_button_2')}</a>
                    </div>
                </div>
            </div>

            {/* <div className="container content files">
                <div className="heading mb-5">
                    <h4>{t("elsupply.pricelist_subtitle")}</h4>
                    <h3>{t("elsupply.pricelist_title")}</h3>
                </div>
                <div className="row">
                    <div className="col-lg-6 files_holder files-left">
                        <div className="file">
                            <p><strong>{t('elsupply.pricelist_1_title')}</strong><br /><small>{t('elsupply.pricelist_1_text')}</small></p>
                            <a href="" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/icons/download.png`} alt="icon download" /></a>
                        </div>
                        <div className="file">
                            <p><strong>{t('elsupply.pricelist_2_title')}</strong><br /><small>{t('elsupply.pricelist_2_text')}</small></p>
                            <a href="" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/icons/download.png`} alt="icon download" /></a>
                        </div>
                        <div className="file">
                            <p><strong>{t('elsupply.pricelist_3_title')}</strong><br /><small>{t('elsupply.pricelist_3_text')}</small></p>
                            <a href="" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/icons/download.png`} alt="icon download" /></a>
                        </div>
                    </div>
                    <div className="col-lg-6 files_holder files-right">
                        <div className="file">
                            <p><strong>{t('elsupply.pricelist_4_title')}</strong><br /><small>{t('elsupply.pricelist_4_text')}</small></p>
                            <a href="" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/icons/download.png`} alt="icon download" /></a>
                        </div>
                        <div className="file">
                            <p><strong>{t('elsupply.pricelist_5_title')}</strong><br /><small>{t('elsupply.pricelist_5_text')}</small></p>
                            <a href="" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/icons/download.png`} alt="icon download" /></a>
                        </div>
                        <div className="file">
                            <p><strong>{t('elsupply.pricelist_6_title')}</strong><br /><small>{t('elsupply.pricelist_6_text')}</small></p>
                            <a href="" target="_blank"><img src={`${process.env.PUBLIC_URL}/images/icons/download.png`} alt="icon download" /></a>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="container content files">
                <div className="heading mb-5">
                    <h3>{t("elsupply.faq_title")}</h3>
                </div>
                <div class="accordion accordion-flush" id="faqAccordion">
                    <div class="accordion-item">
                        <h4 class="accordion-header" id="q1">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q1-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q1")}
                            </button>
                        </h4>
                        <div id="q1-collapse" class="accordion-collapse collapse" aria-labelledby="q1" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a1") }}></p></div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h4 class="accordion-header" id="q2">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q2-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q2")}
                            </button>
                        </h4>
                        <div id="q2-collapse" class="accordion-collapse collapse" aria-labelledby="q2" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a2") }}></p></div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h4 class="accordion-header" id="q3">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q3-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q3")}
                            </button>
                        </h4>
                        <div id="q3-collapse" class="accordion-collapse collapse" aria-labelledby="q3" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a3") }}></p></div>
                        </div>
                    </div>

                    {/* <div class="accordion-item">
                        <h4 class="accordion-header" id="q4">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q4-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q4")}
                            </button>
                        </h4>
                        <div id="q4-collapse" class="accordion-collapse collapse" aria-labelledby="q4" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a4") }}></p></div>
                        </div>
                    </div> */}

                    <div class="accordion-item">
                        <h4 class="accordion-header" id="q5">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q5-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q5")}
                            </button>
                        </h4>
                        <div id="q5-collapse" class="accordion-collapse collapse" aria-labelledby="q5" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a5") }}></p></div>
                        </div>
                    </div>

                    {/* <div class="accordion-item">
                        <h4 class="accordion-header" id="q6">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q6-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q6")}
                            </button>
                        </h4>
                        <div id="q6-collapse" class="accordion-collapse collapse" aria-labelledby="q6" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a6") }}></p></div>
                        </div>
                    </div> */}

                    <div class="accordion-item">
                        <h4 class="accordion-header" id="q7">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q7-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q7")}
                            </button>
                        </h4>
                        <div id="q7-collapse" class="accordion-collapse collapse" aria-labelledby="q7" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a7") }}></p></div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h4 class="accordion-header" id="q8">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q8-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q8")}
                            </button>
                        </h4>
                        <div id="q8-collapse" class="accordion-collapse collapse" aria-labelledby="q8" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a8") }}></p></div>
                        </div>
                    </div>

                    <div class="accordion-item">
                        <h4 class="accordion-header" id="q9">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#q9-collapse" aria-expanded="false" aria-controls="flush-collapseOne">
                                {t("elsupply.companies.q9")}
                            </button>
                        </h4>
                        <div id="q9-collapse" class="accordion-collapse collapse" aria-labelledby="q9" data-bs-parent="#faqAccordion">
                            <div class="accordion-body"><p dangerouslySetInnerHTML={{ __html: t("elsupply.companies.a9") }}></p></div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
};

export default SupplyCompanies;
